
  import { defineComponent } from 'vue'
  import Sidebar from '../components/Sidebar.vue'

  export default defineComponent({
    name: 'Public',
    components: {
      Sidebar,
    },
    data() {
      return {
        query: '',
      }
    },
    methods: {
      callPublicFromQuery(query: string): void {
        this.$store.dispatch('decks/publicFromQuery', this.query)
      },
    },
  })
